// src/pages/admin/components/AdminSidebar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';

function AdminSidebar({ activeItem }) {
  const navigate = useNavigate();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  
  const handleLogout = () => {
    // Clear admin token from local storage
    localStorage.removeItem('adminToken');
    // Redirect to login page
    navigate('/admin/login');
  };
  
  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };
  
  const closeMobileMenu = () => {
    setIsMobileOpen(false);
  };
  
  // Close menu when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileOpen && !event.target.closest('.admin-sidebar') && !event.target.closest('.mobile-menu-toggle')) {
        setIsMobileOpen(false);
      }
    };
    
    if (isMobileOpen) {
      document.addEventListener('click', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobileOpen]);
  
  // Close menu on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [activeItem]);
  
  return (
    <>
      {/* Mobile Menu Toggle Button */}
      <button 
        className="mobile-menu-toggle"
        onClick={toggleMobileMenu}
        style={{ display: window.innerWidth <= 768 ? 'block' : 'none' }}
      >
        {isMobileOpen ? <FaTimes /> : <FaBars />}
      </button>
      
      {/* Overlay for mobile */}
      {isMobileOpen && (
        <div 
          className="mobile-overlay"
          onClick={closeMobileMenu}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            display: window.innerWidth <= 768 ? 'block' : 'none'
          }}
        />
      )}
      
      <div className={`admin-sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
      <h2>Admin Panel</h2>
      
      <ul>
          <li>
            <Link 
              to="/admin/dashboard" 
              className={activeItem === 'dashboard' ? 'active' : ''}
            >
              Dashboard
            </Link>
          </li>
          <li>
            <Link 
              to="/admin/devices" 
              className={activeItem === 'devices' ? 'active' : ''}
            >
              Manage Devices
            </Link>
          </li>
          <li>
            <Link 
              to="/admin/repairs" 
              className={activeItem === 'repairs' ? 'active' : ''}
            >
              Manage Repairs
            </Link>
          </li>
          <li>
            <Link 
              to="/admin/media" 
              className={activeItem === 'media' ? 'active' : ''}
            >
              Media & Content
            </Link>
          </li>
          <li>
            <Link 
              to="/admin/analytics" 
              className={activeItem === 'analytics' ? 'active' : ''}
            >
              Analytics
            </Link>
          </li>
        </ul>
      
      <div className="admin-sidebar-footer">
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
        <Link to="/" className="view-site-link">
          View Web App
        </Link>
      </div>
    </div>
    </>
  );
}

export default AdminSidebar;